import React from "react";
import logo from "../../Assets/Images/h-rooms-01.png";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowLeft, faCheckCircle } from "@fortawesome/free-solid-svg-icons";
import { NavLink } from "react-router-dom";
import moment from "moment";
function Submitted() {
  return (
    <>
      <div className="login1">
        <div
          className="container d-flex flex-column justify-content-between"
          style={{ height: "100vh" }}
        >
          <div className="d-flex flex-column align-items-center justify-content-center flex-grow-1">
          <div className="text-center">
            <img src={logo} className="login-logo mt-3 text-center" alt="logo" />
          </div>
            <div className="w-100 mt-4">
              <div className="register-form">
                <div className="m-4">
                  <h6>
                    Application Submitted{" "}
                    <FontAwesomeIcon
                      style={{ color: "green" }}
                      icon={faCheckCircle}
                    />
                  </h6>
                  <p className="mt-3">
                  Your application has been submitted! Haramayn Rooms Team will review and approve your account within 24 to 48 hours.
                  </p>
                  <NavLink to='/'>
                  <button className="btn btn-secondary text-dark mt-3">
                    <FontAwesomeIcon className="me-2" icon={faArrowLeft} />
                    Back to Login
                  </button>
                  </NavLink>
                </div>
              </div>
            </div>
          <div className="login-footer mb-3 text-center mt-5">
            <p className="text-center">© {moment().format("YYYY")} Haramayn Rooms All Rights Reserved</p>
          </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default Submitted;
